import {useEffect, useState, useContext} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import DropdownButton from "react-bootstrap/DropdownButton";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";

import AuthContext from "context/AuthContext";
import ModalRoutesStaticSelect from "site-apps/distribution/route/ModalRoutesStaticSelect";
import ModalRoutesDynamicSelect from "site-apps/distribution/dynamic/ModalRoutesDynamicSelect";
import ModalRoutesFlyTippingSelect from "site-apps/distribution/route/ModalRoutesFlyTippingSelect";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";
import ConditionalRender from "components/ConditionalRender";
import {REQUIRES_FIELDS, DEFAULT_REQUIRES} from "site-apps/distribution/route/RouteRequires";

class ProgrammingRoute {
    constructor(item, type, requires) {
        this.id = "";
        this.item = item;
        this.name = item.name;
        this.type = type;
        this.last_date = null;
        this.requires = requires;
        this.truck_id = null;
        this.driver_id = null;
    }
}

const FormTabRoutes = ({routes, setRoutes}) => {
    const {panel} = useContext(AuthContext);
    // Prefill desde el panel (comportamiento anterior). Para reactivarlo,
    // usa `panelRequires` en `new ProgrammingRoute(...)` y en el `disabled`.
    // const panelRequires = (panel && panel.requires) || {};
    const [showModalRoutesStatic, setShowModalRoutesStatic] = useState(false);
    const [showModalRoutesDynamic, setShowModalRoutesDynamic] = useState(false);
    const [showModalRoutesFlyTipping, setShowModalRoutesFlyTipping] = useState(false);
    const [routesStatic, setRoutesStatic] = useState([]);
    const [routesDynamic, setRoutesDynamic] = useState([]);
    const [routesFlyTipping, setRoutesFlyTipping] = useState([]);

    const setRouteRequires = (index, key, value) => {
        setRoutes((current) =>
            current.map((route, idx) => {
                if (idx !== index) return route;
                return {
                    ...route,
                    requires: {...(route.requires || {}), [key]: value},
                };
            })
        );
    };

    useEffect(() => {
        if (routes.length) {
            const routesStatic_ = [];
            const routesDynamic_ = [];
            const routesFlyTipping_ = [];
            routes.forEach((_item) => {
                switch (_item.type) {
                    case "s":
                        routesStatic_.push(_item.item);
                        break;
                    case "d":
                        routesDynamic_.push(_item.item);
                        break;
                    case "f":
                        routesFlyTipping_.push(_item.item);
                        break;
                    default:
                        break;
                }
            });
            setRoutesStatic([...routesStatic_]);
            setRoutesDynamic([...routesDynamic_]);
            setRoutesFlyTipping([...routesFlyTipping_]);
        }
        return () => {
            unsubscribeEvent("routestatic:modalselect:change", eventChangeRoutesStatic);
            unsubscribeEvent("routesdynamic:modalselect:change", eventChangeRoutesDynamic);
            unsubscribeEvent("routesflytippin:modalselect:change", eventChangeRoutesFlyTipping);
        };
    }, []);

    const handleAddRoutesStatic = () => {
        setShowModalRoutesStatic(true);
        subscribeEvent("routestatic:modalselect:change", eventChangeRoutesStatic);
    };

    const eventChangeRoutesStatic = (e) => {
        const result_ = [...e.detail];
        const routes_ = [];
        const routesStatic_ = [];
        result_.forEach((_item) => {
            if (!routes.some((item) => item.item.id === _item.id && item.type === "s")) {
                routes_.push(new ProgrammingRoute(_item, "s", DEFAULT_REQUIRES));
                routesStatic_.push(_item);
            }
        });
        setRoutes([...routes, ...routes_]);
        setRoutesStatic([...routesStatic, ...routesStatic_]);
        unsubscribeEvent("routestatic:modalselect:change", eventChangeRoutesStatic);
    };

    const handleAddRoutesDynamic = () => {
        setShowModalRoutesDynamic(true);
        subscribeEvent("routesdynamic:modalselect:change", eventChangeRoutesDynamic);
    };
    const eventChangeRoutesDynamic = (e) => {
        const result_ = [...e.detail];
        const routes_ = [];
        const routesDynamic_ = [];
        result_.forEach((_item) => {
            if (!routes.some((item) => item.item.id === _item.id && item.type === "d")) {
                routes_.push(new ProgrammingRoute(_item, "d", DEFAULT_REQUIRES));
                routesDynamic_.push(_item);
            }
        });
        setRoutes([...routes, ...routes_]);
        setRoutesDynamic([...routesDynamic, ...routesDynamic_]);
        unsubscribeEvent("routesdynamic:modalselect:change", eventChangeRoutesDynamic);
    };

    const handleRemoveRoute = (e) => {
        const {type} = e.target;
        const value = type === "button" ? parseInt(e.target.dataset.index) : parseInt(e.currentTarget.dataset.index);

        const item_ = {...routes[value]};
        switch (item_.type) {
            case "s":
                setRoutesStatic(routesStatic.filter((item) => item.id !== item_.item.id));
                break;
            case "d":
                setRoutesDynamic(routesDynamic.filter((item) => item.id !== item_.item.id));
                break;
            case "f":
                setRoutesFlyTipping(routesFlyTipping.filter((item) => item.id !== item_.item.id));
                break;
            default:
                break;
        }
        setRoutes(routes.filter((item, index) => index !== value));
    };
    const handleAddRoutesFlyTipping = () => {
        setShowModalRoutesFlyTipping(true);
        subscribeEvent("routesflytipping:modalselect:change", eventChangeRoutesFlyTipping);
    };

    const eventChangeRoutesFlyTipping = (e) => {
        const result_ = [...e.detail];
        const routes_ = [];
        const routesFlyTipping_ = [];
        result_.forEach((_item) => {
            if (!routes.some((item) => item.item.id === _item.id && item.type === "f")) {
                routes_.push(new ProgrammingRoute(_item, "f", DEFAULT_REQUIRES));
                routesFlyTipping_.push(_item);
            }
        });
        setRoutes([...routes, ...routes_]);
        setRoutesFlyTipping([...routesFlyTipping, ...routesFlyTipping_]);
        unsubscribeEvent("routesflytipping:modalselect:change", eventChangeRoutesFlyTipping);
    };

    const getIconRoute = (type) => {
        switch (type) {
            case "s":
                return <FontAwesomeIcon icon="location-dot" size="2xl" className="text-secondary" />;
            case "d":
                return <FontAwesomeIcon icon="route" size="2xl" className="text-secondary" />;
            case "f":
                return <FontAwesomeIcon icon="sack-xmark" size="2xl" className="text-secondary" />;
        }
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 text-end">
                    <button type="button" className="btn btn-outline-warning me-2" onClick={() => {}} title="Limpiar">
                        <FontAwesomeIcon icon="broom" />
                    </button>
                    <DropdownButton
                        as={ButtonGroup}
                        id="dropdown-selector-containers"
                        variant="outline-primary"
                        title={<FontAwesomeIcon icon="pen" />}>
                        <Dropdown.Item eventKey="s" onClick={handleAddRoutesStatic}>
                            <FontAwesomeIcon icon="location-dot" /> Ruta estatica
                        </Dropdown.Item>
                        <Dropdown.Item eventKey="d" onClick={handleAddRoutesDynamic}>
                            <FontAwesomeIcon icon="route" /> Ruta Dinamica
                        </Dropdown.Item>
                        <Dropdown.Item eventKey="f" onClick={handleAddRoutesFlyTipping}>
                            <FontAwesomeIcon icon="sack-xmark" /> Ruta Bolseo
                        </Dropdown.Item>
                    </DropdownButton>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th style={{width: "42px"}}></th>
                                <th>Ruta</th>
                                <th className="text-center">Requisitos</th>
                                <th className="text-center" style={{width: "80px"}}>
                                    Acciones
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {routes.map((item, index) => (
                                <tr key={index}>
                                    <td style={{verticalAlign: "middle"}} className="text-center">
                                        {getIconRoute(item.type)}
                                    </td>
                                    <td style={{verticalAlign: "middle"}}>{item.name}</td>
                                    <td style={{verticalAlign: "middle"}}>
                                        <div className="d-flex flex-wrap justify-content-center gap-2">
                                            {REQUIRES_FIELDS.map(({key, label}) => (
                                                <div
                                                    key={key}
                                                    className="d-flex align-items-center gap-1"
                                                    title={label}>
                                                    <small className="text-muted">{label}</small>
                                                    <Form.Check
                                                        type="switch"
                                                        checked={!!(item.requires || {})[key]}
                                                        // disabled={!panelRequires[key]}
                                                        onChange={(e) =>
                                                            setRouteRequires(index, key, e.target.checked)
                                                        }
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-link text-body-tertiary"
                                            title="Borrar"
                                            data-index={index}
                                            onClick={handleRemoveRoute}>
                                            <FontAwesomeIcon icon="trash" size="xl" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
            <ConditionalRender condition={showModalRoutesStatic}>
                <ModalRoutesStaticSelect
                    show={showModalRoutesStatic}
                    setShow={setShowModalRoutesStatic}
                    multiple={true}
                    chosenIn={routesStatic}
                    subtitle={document.title}
                />
            </ConditionalRender>
            <ConditionalRender condition={showModalRoutesDynamic}>
                <ModalRoutesDynamicSelect
                    show={showModalRoutesDynamic}
                    setShow={setShowModalRoutesDynamic}
                    multiple={true}
                    chosenIn={routesDynamic}
                    subtitle={document.title}
                />
            </ConditionalRender>
            <ConditionalRender condition={showModalRoutesFlyTipping}>
                <ModalRoutesFlyTippingSelect
                    show={showModalRoutesFlyTipping}
                    setShow={setShowModalRoutesFlyTipping}
                    multiple={true}
                    chosenIn={routesFlyTipping}
                    subtitle={document.title}
                />
            </ConditionalRender>
        </div>
    );
};
export default FormTabRoutes;
